import { render, staticRenderFns } from "./WaveformTableBase.vue?vue&type=template&id=4d721cd8&scoped=true"
import script from "./WaveformTableBase.vue?vue&type=script&lang=js"
export * from "./WaveformTableBase.vue?vue&type=script&lang=js"
import style0 from "./WaveformTableBase.vue?vue&type=style&index=0&id=4d721cd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d721cd8",
  null
  
)

export default component.exports